export const formations = {
  football: {
    "4-4-2": [
      { id: "GK", label: "GK", x: 50, y: 92 },
      { id: "LB", label: "LB", x: 14, y: 72 },
      { id: "LCB", label: "LCB", x: 37, y: 74 },
      { id: "RCB", label: "RCB", x: 63, y: 74 },
      { id: "RB", label: "RB", x: 86, y: 72 },
      { id: "LM", label: "LM", x: 14, y: 48 },
      { id: "LCM", label: "LCM", x: 38, y: 48 },
      { id: "RCM", label: "RCM", x: 62, y: 48 },
      { id: "RM", label: "RM", x: 86, y: 48 },
      { id: "LST", label: "LST", x: 38, y: 20 },
      { id: "RST", label: "RST", x: 62, y: 20 }
    ],
    "4-3-3": [
      { id: "GK", label: "GK", x: 50, y: 92 },
      { id: "LB", label: "LB", x: 14, y: 72 },
      { id: "LCB", label: "LCB", x: 37, y: 74 },
      { id: "RCB", label: "RCB", x: 63, y: 74 },
      { id: "RB", label: "RB", x: 86, y: 72 },
      { id: "LCM", label: "LCM", x: 26, y: 50 },
      { id: "CM", label: "CM", x: 50, y: 52 },
      { id: "RCM", label: "RCM", x: 74, y: 50 },
      { id: "LW", label: "LW", x: 18, y: 22 },
      { id: "ST", label: "ST", x: 50, y: 16 },
      { id: "RW", label: "RW", x: 82, y: 22 }
    ],
    "4-2-3-1": [
      { id: "GK", label: "GK", x: 50, y: 92 },
      { id: "LB", label: "LB", x: 14, y: 72 },
      { id: "LCB", label: "LCB", x: 37, y: 74 },
      { id: "RCB", label: "RCB", x: 63, y: 74 },
      { id: "RB", label: "RB", x: 86, y: 72 },
      { id: "LDM", label: "LDM", x: 35, y: 56 },
      { id: "RDM", label: "RDM", x: 65, y: 56 },
      { id: "LAM", label: "LAM", x: 20, y: 34 },
      { id: "CAM", label: "CAM", x: 50, y: 36 },
      { id: "RAM", label: "RAM", x: 80, y: 34 },
      { id: "ST", label: "ST", x: 50, y: 14 }
    ],
    "4-1-4-1": [
      { id: "GK", label: "GK", x: 50, y: 92 },
      { id: "LB", label: "LB", x: 14, y: 72 },
      { id: "LCB", label: "LCB", x: 37, y: 74 },
      { id: "RCB", label: "RCB", x: 63, y: 74 },
      { id: "RB", label: "RB", x: 86, y: 72 },
      { id: "CDM", label: "CDM", x: 50, y: 56 },
      { id: "LM", label: "LM", x: 14, y: 38 },
      { id: "LCM", label: "LCM", x: 37, y: 38 },
      { id: "RCM", label: "RCM", x: 63, y: 38 },
      { id: "RM", label: "RM", x: 86, y: 38 },
      { id: "ST", label: "ST", x: 50, y: 14 }
    ],
    "4-5-1": [
      { id: "GK", label: "GK", x: 50, y: 92 },
      { id: "LB", label: "LB", x: 14, y: 72 },
      { id: "LCB", label: "LCB", x: 37, y: 74 },
      { id: "RCB", label: "RCB", x: 63, y: 74 },
      { id: "RB", label: "RB", x: 86, y: 72 },
      { id: "LM", label: "LM", x: 10, y: 48 },
      { id: "LCM", label: "LCM", x: 32, y: 48 },
      { id: "CM", label: "CM", x: 50, y: 50 },
      { id: "RCM", label: "RCM", x: 68, y: 48 },
      { id: "RM", label: "RM", x: 90, y: 48 },
      { id: "ST", label: "ST", x: 50, y: 16 }
    ],
    "4-3-1-2": [
      { id: "GK", label: "GK", x: 50, y: 92 },
      { id: "LB", label: "LB", x: 14, y: 72 },
      { id: "LCB", label: "LCB", x: 37, y: 74 },
      { id: "RCB", label: "RCB", x: 63, y: 74 },
      { id: "RB", label: "RB", x: 86, y: 72 },
      { id: "LCM", label: "LCM", x: 25, y: 54 },
      { id: "CDM", label: "CDM", x: 50, y: 58 },
      { id: "RCM", label: "RCM", x: 75, y: 54 },
      { id: "CAM", label: "CAM", x: 50, y: 36 },
      { id: "LST", label: "LST", x: 36, y: 16 },
      { id: "RST", label: "RST", x: 64, y: 16 }
    ],
    "3-5-2": [
      { id: "GK", label: "GK", x: 50, y: 92 },
      { id: "LCB", label: "LCB", x: 25, y: 76 },
      { id: "CB", label: "CB", x: 50, y: 78 },
      { id: "RCB", label: "RCB", x: 75, y: 76 },
      { id: "LWB", label: "LWB", x: 8, y: 52 },
      { id: "LCM", label: "LCM", x: 30, y: 52 },
      { id: "CM", label: "CM", x: 50, y: 54 },
      { id: "RCM", label: "RCM", x: 70, y: 52 },
      { id: "RWB", label: "RWB", x: 92, y: 52 },
      { id: "LST", label: "LST", x: 38, y: 20 },
      { id: "RST", label: "RST", x: 62, y: 20 }
    ],
    "3-4-3": [
      { id: "GK", label: "GK", x: 50, y: 92 },
      { id: "LCB", label: "LCB", x: 25, y: 76 },
      { id: "CB", label: "CB", x: 50, y: 78 },
      { id: "RCB", label: "RCB", x: 75, y: 76 },
      { id: "LM", label: "LM", x: 12, y: 52 },
      { id: "LCM", label: "LCM", x: 38, y: 52 },
      { id: "RCM", label: "RCM", x: 62, y: 52 },
      { id: "RM", label: "RM", x: 88, y: 52 },
      { id: "LW", label: "LW", x: 18, y: 22 },
      { id: "ST", label: "ST", x: 50, y: 16 },
      { id: "RW", label: "RW", x: 82, y: 22 }
    ],
    "3-4-1-2": [
      { id: "GK", label: "GK", x: 50, y: 92 },
      { id: "LCB", label: "LCB", x: 25, y: 76 },
      { id: "CB", label: "CB", x: 50, y: 78 },
      { id: "RCB", label: "RCB", x: 75, y: 76 },
      { id: "LM", label: "LM", x: 12, y: 52 },
      { id: "LCM", label: "LCM", x: 38, y: 52 },
      { id: "RCM", label: "RCM", x: 62, y: 52 },
      { id: "RM", label: "RM", x: 88, y: 52 },
      { id: "CAM", label: "CAM", x: 50, y: 32 },
      { id: "LST", label: "LST", x: 36, y: 14 },
      { id: "RST", label: "RST", x: 64, y: 14 }
    ],
    "5-3-2": [
      { id: "GK", label: "GK", x: 50, y: 92 },
      { id: "LWB", label: "LWB", x: 8, y: 70 },
      { id: "LCB", label: "LCB", x: 28, y: 76 },
      { id: "CB", label: "CB", x: 50, y: 78 },
      { id: "RCB", label: "RCB", x: 72, y: 76 },
      { id: "RWB", label: "RWB", x: 92, y: 70 },
      { id: "LCM", label: "LCM", x: 25, y: 48 },
      { id: "CM", label: "CM", x: 50, y: 50 },
      { id: "RCM", label: "RCM", x: 75, y: 48 },
      { id: "LST", label: "LST", x: 38, y: 18 },
      { id: "RST", label: "RST", x: 62, y: 18 }
    ],
    "5-4-1": [
      { id: "GK", label: "GK", x: 50, y: 92 },
      { id: "LWB", label: "LWB", x: 8, y: 70 },
      { id: "LCB", label: "LCB", x: 28, y: 76 },
      { id: "CB", label: "CB", x: 50, y: 78 },
      { id: "RCB", label: "RCB", x: 72, y: 76 },
      { id: "RWB", label: "RWB", x: 92, y: 70 },
      { id: "LM", label: "LM", x: 14, y: 46 },
      { id: "LCM", label: "LCM", x: 38, y: 48 },
      { id: "RCM", label: "RCM", x: 62, y: 48 },
      { id: "RM", label: "RM", x: 86, y: 46 },
      { id: "ST", label: "ST", x: 50, y: 16 }
    ]
  },

  futsal: {
    "1-2-1": [
      { id: "GK", label: "GK", x: 50, y: 90 },
      { id: "FIXO", label: "FIXO", x: 50, y: 70 },
      { id: "LA", label: "LA", x: 20, y: 48 },
      { id: "RA", label: "RA", x: 80, y: 48 },
      { id: "PIVOT", label: "PIVOT", x: 50, y: 22 }
    ],
    "2-2": [
      { id: "GK", label: "GK", x: 50, y: 90 },
      { id: "LD", label: "LD", x: 30, y: 65 },
      { id: "RD", label: "RD", x: 70, y: 65 },
      { id: "LA", label: "LA", x: 30, y: 28 },
      { id: "RA", label: "RA", x: 70, y: 28 }
    ],
    "3-1": [
      { id: "GK", label: "GK", x: 50, y: 90 },
      { id: "LD", label: "LD", x: 22, y: 68 },
      { id: "CD", label: "CD", x: 50, y: 70 },
      { id: "RD", label: "RD", x: 78, y: 68 },
      { id: "PIVOT", label: "PIVOT", x: 50, y: 26 }
    ],
    "1-3": [
      { id: "GK", label: "GK", x: 50, y: 90 },
      { id: "FIXO", label: "FIXO", x: 50, y: 68 },
      { id: "LA", label: "LA", x: 22, y: 32 },
      { id: "CA", label: "CA", x: 50, y: 26 },
      { id: "RA", label: "RA", x: 78, y: 32 }
    ],
    "4-0": [
      { id: "GK", label: "GK", x: 50, y: 90 },
      { id: "LD", label: "LD", x: 30, y: 60 },
      { id: "RD", label: "RD", x: 70, y: 60 },
      { id: "LA", label: "LA", x: 30, y: 34 },
      { id: "RA", label: "RA", x: 70, y: 34 }
    ]
  }
};

export const formationSizes = {
  football: 11,
  futsal: 5
};
